import React from 'react';
import classnames from 'classnames';

export default function PrimaryButton({ children, disabled, ...rest }) {
  return (
    <a
      className={classnames(
        'button button--primary',
        disabled && 'button--disabled',
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </a>
  );
}